import * as React from 'react';
import styled from 'styled-components';

import * as colors from '../../shared/colors';
import t from '../../shared/translations';
import OpenChatButton from '../chat/OpenChatButton';
import SendButton from '../messages/SendButton';

interface IMember {
    id: string;
    person: {
        id: string;
        profilePicSrc: string;
        firstName: string;
        lastName: string;
    };
}

interface IProps {
    members: IMember[];
}

const buttonColor = 'white';
const backgroupColor = colors.altSecondaryColor;
const borderColor: string | null = null;
const textColor = 'white';

const Wrapper = styled.div`
    margin-bottom: 0.5rem;
    padding: 0.6rem;
    background-color: ${backgroupColor};
    border: ${borderColor ? `1px solid ${borderColor}` : 'none'};
    border-radius: 1rem;
    color: ${textColor};

    @media (min-width: 640px) {
        margin-bottom: 1rem;
        padding: 1rem;
    }
    h3 {
        color: ${textColor};
    }
`;

const Row = styled.div`
    display: flex;
    margin: 0 -10px;
    flex-wrap: wrap;
    > * {
        margin: 0 10px;
    }
`;

const PplCol = styled.div`
    flex-grow: 1;
`;

const BtnCol = styled.div`
    text-align: right;
    > button {
        color: ${colors.altPrimaryColor};
        border: 3px solid ${colors.altPrimaryColor};
    }
`;

const MemberBox = styled.div`
    width: 80px;
    text-align: center;
    font-size: 0.85rem;
    margin-bottom: 0.5rem;
    @media (min-width: 640px) {
        margin-bottom: 1rem;
        font-size: 1rem;
        width: 90px;
    }
`;

const ImgTainer = styled.div`
    border-radius: 50%;
    overflow: hidden;
    img {
        width: 80px;
        height: 80px;
        object-fit: cover;

        @media (min-width: 640px) {
            font-size: 1rem;
            width: 90px;
        }
    }
`;

function YourGroup({ members }: IProps): JSX.Element {
    return <Wrapper>
        <div>
            <h3>{t('player.pip.heading-your-group')}</h3>
            <Row>
                <PplCol>
                    <Row>
                        {members.map(m => <MemberBox key={m.id}>
                            <ImgTainer>
                                <img
                                    src={m.person.profilePicSrc || '/static/images/profile-silouette.png'}
                                    alt='profile picture'
                                />
                            </ImgTainer>
                            <div>{m.person.firstName} {m.person.lastName}</div>
                        </MemberBox>)}
                    </Row>
                </PplCol>
                <BtnCol>
                    <SendButton color={buttonColor} /><br />
                    <OpenChatButton color={buttonColor} />
                </BtnCol>
            </Row>
        </div>
    </Wrapper>;
}

export default YourGroup;
